import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { getParlamentDecisionById, getParlamentDecisions } from '../../api/councilService';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';
import QuickMenu from '../../components/QuickMenu/QuickMenu';
import { FaCalendarAlt, FaInfoCircle, FaFileDownload } from 'react-icons/fa';

const formatDecisionDate = (dateString) => {
  if (!dateString) {
    return '-';
  }

  const date = new Date(dateString);
  return Number.isNaN(date.getTime()) ? dateString : format(date, 'dd MMMM yyyy', { locale: tr });
};

export default function CouncilDetail() {
  const params = useParams();
  const location = useLocation();
  const guidFromState = location.state?.guid;
  const routeKey = params.urlTag || params.id || params['*'];
  const [decision, setDecision] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDecisionDetail = async () => {
      try {
        setLoading(true);
        setError(null);
        setDecision(null);

        let resolvedGuid = guidFromState;

        if (!resolvedGuid && routeKey) {
          const decisionsResponse = await getParlamentDecisions(1, 1000);

          if (decisionsResponse.isSuccess && decisionsResponse.data?.items) {
            const matchedDecision = decisionsResponse.data.items.find(
              (item) => item.urlTag === routeKey || item.guid === routeKey
            );

            if (matchedDecision) {
              resolvedGuid = matchedDecision.guid;
            } else {
              setError('Karar bulunamadı');
              return;
            }
          } else {
            setError('Kararlar yüklenirken bir hata oluştu');
            return;
          }
        }

        if (!resolvedGuid) {
          setError('Karar bilgisi bulunamadı');
          return;
        }

        const response = await getParlamentDecisionById(resolvedGuid);

        if (response.isSuccess && response.data) {
          setDecision(response.data);
        } else {
          setError('Karar detayı yüklenirken bir hata oluştu');
        }
      } catch (err) {
        setError('Karar detayı yüklenirken bir hata oluştu');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchDecisionDetail();
  }, [guidFromState, routeKey]);

  const handleDownload = () => {
    if (decision?.fileUrl) {
      window.open(decision.fileUrl, '_blank');
    }
  };

  if (loading) {
    return (
      <div className="council-decisions-detail-page">
        <div className="container py-5">
          <div className="text-center py-5">
            <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
          </div>
        </div>
      </div>
    );
  }

  if (error || !decision) {
    return (
      <div className="council-decisions-detail-page">
        <div className="container py-5">
          <div className="alert alert-danger">
            {error || 'Karar bulunamadı'}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="council-decisions-detail-page">
      <div className="container py-5">
        <div className="row">
          <QuickMenu />

          <div className="col-md-10">
            <div className="council-detail-card">
              <div className="detail-header">
                <h2>{decision.header}</h2>
                
                <div className="detail-meta-grid">
                  <div className="meta-item">
                    <FaCalendarAlt />
                    <span className="meta-label">Karar Tarihi:</span>
                    <span>{formatDecisionDate(decision.date)}</span>
                  </div>
                  
                  <div className="meta-item">
                    <FaInfoCircle />
                    <span className="meta-label">Karar No:</span>
                    <span>{decision.decisionsNo || '-'}</span>
                  </div>
                </div>
              </div>

              <div className="detail-body-section">
                <h3>Karar Özeti / Detayı</h3>
                <div
                  className="detail-text"
                  dangerouslySetInnerHTML={{ __html: decision.detail || '' }}
                />
              </div>

              {decision.fileUrl && (
                <div className="detail-action-section">
                  <button type="button" className="download-btn" onClick={handleDownload}>
                    <FaFileDownload />
                    <span>Karar Dosyasını İndir</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
